module.exports = __webpack_public_path__ + "img/23.7b431514.png";